import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import * as moment from 'moment';
import { ImportStudent } from '@ascschool/model/school/import-student';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { StudentService } from '@ascschool/services/school/student.service';
import { ImportStaff } from '@ascschool/model/user/staff-personnel-import';
import { StaffService } from '@ascschool/services/user/staff.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TypeOfPersonnelService } from '@ascschool/services/category/type-of-personnel.service';

interface TypeOfPersonnelRadio {
  id: number;
  typeOfPersonnelName: string;
  formType: number;
  displayOrder: number;
}
@Component({
  selector: 'app-popup-import-ttns',
  templateUrl: './popup-import-ttns.component.html',
  styleUrls: ['./popup-import-ttns.component.scss']
})
export class PopupImportTtnsComponent implements OnInit {
  @Input() schoolId: number;
  @Input() provinceId: number;
  getSchoolACFn: (value: any) => Observable<any>;
  schoolSubscription: any;
  currentUser: any;
  fileImport: File;
  discoloration: any;
  importStaff = new ImportStaff();
  isImporting: Boolean = false;
  errorMsg: string;
  isDisabled = false;
  schoolName: string;
  commonFilter: CommonFilter = new CommonFilter();
  isEditMode = false;
  validateForm = this.fb.group({
    schoolId: [null, [Validators.required]],
  });
  formType: number; 
  typeOfPersonnels: TypeOfPersonnelRadio[];
  schoolControl = this.validateForm.controls.schoolId;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    public utilsService: UtilsService,
    private schoolService: SchoolService,
    private service: StaffService,
    public utils: UtilsService,
    private fb: FormBuilder,
    private typeOfPersonnelService: TypeOfPersonnelService
  ) {
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    this.importStaff.schoolId = this.schoolId;
    if (this.importStaff.schoolId) {
      this.schoolService.GetSelectPagingById(this.importStaff.schoolId).subscribe((res) => {
        this.schoolControl.setValue({ id: res.id, text: res.educationAndTrainingName });
      });
    }
    this.loadTypeofPersonnel();
    this.loadSchool();
  }
  loadSchool() {
    // tslint:disable-next-line: max-line-length
    this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.schoolSubscription) {
      this.schoolSubscription = this.schoolControl.valueChanges.subscribe(() => {
        this.utils.bindOrUnBindTheId(this.importStaff, 'schoolId', this.schoolControl.value);
      });
    }
  }

  changeSchool(control: FormControl) {
    this.schoolControl = control;

  }
  import() {
    if (!this.schoolId && !this.schoolControl.value) {
      this.importStaff.schoolId = this.currentUser.eadId;
    }
    if (this.importStaff.schoolId) {
      if (this.importStaff.tenFile !== '') {
        this.isImporting = true;
        this.service.importNhanSu(this.fileImport, this.importStaff).subscribe(res => {
          if (res.statusCode === 0) {
            this.discoloration = true;
          }
          if (res !== 0 && res !== null) {
            this.importStaff.ketQuaImport = 'Import dữ liệu: ' + res.message;
          }
          else if (res !== null) {
            this.importStaff.ketQuaImport = 'Import dữ liệu dữ liệu đã bị trùng';
          } else {
            this.importStaff.ketQuaImport = 'Import dữ liệu không đúng mẫu!';
          }
          this.isImporting = false;
        }, () => {
          this.isImporting = false;
        });
        this.importStaff.tenFile = '';
        (document.getElementById('file-selector') as HTMLInputElement).value = '';
      }
      else {
        this.importStaff.ketQuaImport = 'Không có file!';
      }
    } else {
      // tslint:disable-next-line: forin
      for (const i in this.validateForm.controls) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
  }
  suffixFileClick() {
    if (this.importStaff.tenFile === '') { this.utils.chooseFile(); }
    else {
      this.importStaff.tenFile = '';
      (document.getElementById('file-selector') as HTMLInputElement).value = '';
    }
  }
  finishUpload(file: FileList) {
    this.fileImport = file[0];
    this.importStaff.tenFile = file[0].name;
  }
  taiVe() {
    if (this.formType) {
      if (this.formType === 1) {
        this.service.downloadTemplate().subscribe((data) => {
          let downloadURL = window.URL.createObjectURL(data);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'NhanSuTemplate.xlsx';
          link.click();
        });
      } else if (this.formType === 2) {
        this.service.downloadTemplateGV().subscribe((data) => {
          let downloadURL = window.URL.createObjectURL(data);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'NhanSuTemplate.xlsx';
          link.click();
        });
      } else {
        this.service.downloadTemplateNVTL().subscribe((data) => {
          let downloadURL = window.URL.createObjectURL(data);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'NhanSuTemplate.xlsx';
          link.click();
        });
      }
    } else {
      this.msg.warning('Vui lòng chọn loại nhân sự')
    }
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin: ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }


  loadTypeofPersonnel() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = 200;
    this.typeOfPersonnelService.getTypeOfPersonnelSelectPaging(this.commonFilter).subscribe((res: any) => { 
      if (res.results !== null) {
        this.typeOfPersonnels = res.results;
        this.typeOfPersonnels = this.typeOfPersonnels.sort((a, b) => (a.displayOrder < b.displayOrder ? -1 : 1));
        let item = this.typeOfPersonnels[0];
        this.formType = item.formType;
        this.importStaff.typeOfPersonnel = item.id;
      }
    });
  }

  onChangeStatus(event: any): void {
    let selectRadio = this.typeOfPersonnels.find(x => x.id === event);
    this.formType = selectRadio.formType;
  }

}
